<template lang="pug">
  .max-w-320.mx-auto.mx-lg-0
    h4.mb-2 Set Password
    p.mb-0 Welcome
    p.fs-14.mb-5 Please set a password for your account.

    .alert.alert-danger(v-if="hasError")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  {{ errorMessage }}

    .alert.alert-danger(v-if="checkEmail")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  Please check your email for link to reset your password

    el-form(
        v-if="!checkEmail"
        :model="resetPassword"
        ref="resetPassword"
        :rules="rules"
        @submit.native.prevent="validateForm('resetPassword')"
      )
      el-form-item(prop="password").mb-4
        el-input(v-model="resetPassword.password"
          type="password"
          placeholder="New Password"
          autoComplete="off"
        )
      el-form-item(prop="confirmPassword").mb-4
        el-input(v-model="resetPassword.confirmPassword"
          type="password"
          placeholder="New Password"
          autoComplete="off"
        )
      el-form-item.mb-4
        el-button(
          type="primary",
          native-type="submit"
          v-loading.fullscreen.lock="loading"
        ).w-100 Submit

    div
      .fs-12 Already have an account?
       router-link(to="/sign-in").d-block Sign In
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    const checkPassword = (rule, value, callback) => {
      if (this.resetPassword.password === value) {
        callback();
      }
      callback(new Error('Please confirm your password'));
    };

    return {
      resetPassword: {
        username: '',
        code: '',
        password: '',
        confirmPassword: '',
      },
      message: 'message',
      loading: false,
      hasError: false,
      errorMessage: '',
      checkEmail: false,
      rules: {
        username: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],
        code: { required: true, message: 'Please enter code', trigger: 'blur' },
        password: { required: true, message: 'Please enter your password', trigger: 'blur' },
        confirmPassword: [
          { required: true, message: 'Please confirm your password', trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' },
        ],
      },
    };
  },

  mounted() {
    if (this.$route.query.from && this.$route.query.from === 'forgotPassword') {
      this.checkEmail = true;
    } else {
      this.init();
    }
  },

  methods: {

    init() {
      const { data, code } = this.$route.query;
      const decoded = JSON.parse(atob(data));
      if (decoded.email && code) {
        this.resetPassword.username = decoded.email;
        this.resetPassword.code = code;
      } else {
        console.log('errror go to auth');
      }
    },

    validateEmail() {
      this.$refs.resetPassword.validateField('email', (valid) => !!valid);
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.cognitoResetPassword();
        }
        return false;
      });
    },
    cognitoResetPassword() {
      this.loading = true;
      this.$Amplify.Auth.forgotPasswordSubmit(
        this.resetPassword.username,
        this.resetPassword.code,
        this.resetPassword.password,
      ).then((r) => {
        console.log(r);
        this.$router.push('/sign-in');
      }).catch((e) => {
        console.log(e);
        this.hasError = true;
        this.errorMessage = e.message;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
